<template>
  <v-dialog v-model="warningModal" persistent max-width="330">
    <v-card
      style="padding: 10px 5px 10px 0; background-color: #F1DBDB; border: 1px solid #FF0000"
    >
      <v-card-text style="padding: 0 27px 0">
        <v-layout row="wrap">
          <v-spacer />
          <v-flex
            shrink
            style="cursor: pointer"
            @click="(warningModal = false), warningModalUpdate()"
          >
            <v-img
              src="@/assets/close.svg"
              aspect-ratio="1.7"
              width="13"
              height="13"
            ></v-img>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text style="padding: 0 27px 0">
        <v-layout align-center>
          <v-flex shrink mr-5>
            <v-img
              :src="require(`@/assets/imgs/warning.png`)"
              aspect-ratio="1.7"
              width="60"
              height="60"
            ></v-img>
          </v-flex>
          <v-flex pt-3>
            <p class="alert-text">
              Please fill in all fields!! for both General and Sale info
            </p>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="#6CC8A0"
          style="color: #fff"
          @click="(warningModal = false), warningModalUpdate()"
          >OK</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    warningModal: Boolean
  },
  data() {
    return {
      // warningModal: { warningModal },
    };
  },
  methods: {
    warningModalUpdate() {
      this.$emit("warningModalUpdate", false);
    }
  }
};
</script>
